import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { catchError } from "rxjs/operators";
import { ConfigurationService } from "../configuration/configuration.service";
import { EndpointFactory } from "../endpoint-factory.service";

@Injectable({
  providedIn: "root",
})
export class NotificationEndpoint extends EndpointFactory {
  constructor(
    http: HttpClient,
    configurations: ConfigurationService,
    injector: Injector
  ) {
    super(http, configurations, injector, "", configurations.webAppApiBaseUrl);
  }

  getNotificationContext(request: any): Promise<any> {

    const url = this.getBaseUrl('notification', 'WEBAPI') + 'notification';

    return this.http
      .post<any>(url, request)
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        })
      )
      .toPromise();
  }

  setNotificationItem(tenantId: string, itemId: number, status: string): Promise<boolean> {
    const url = this.getBaseUrl('notification', 'WEBAPI') + `notificationstatus/${tenantId}/${itemId}/${status}`;

    return this.http
      .post<boolean>(url, null)
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        })
      )
      .toPromise();
  }
}
